import styles from "./ProductSupport.module.scss";
import { MyCasesOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/MyCasesOutlined";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/components/button/Button";
type Props = {
  url: string;
};

export const ProductSupportUI = ({ url }: Props) => (
  <div
    data-testid="product-support"
    className={styles.container}
    data-component="ProductSupport"
  >
    <section className={styles["productSupport"]}>
      <div className={styles["productSupport__content"]}>
        <MyCasesOutlined size="large" />
        <h2 className={styles["productSupport__headline"]}>Laptop support</h2>
        <p>Get up and running smoothly with our product guide and support</p>
        <UnderlinedButton
          tag="a"
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          labelText="Find out more"
        />
      </div>
    </section>
  </div>
);
